import { render, staticRenderFns } from "./knowledge-detail.vue?vue&type=template&id=ad615f4e&scoped=true"
import script from "./knowledge-detail.vue?vue&type=script&lang=js"
export * from "./knowledge-detail.vue?vue&type=script&lang=js"
import style0 from "./knowledge-detail.vue?vue&type=style&index=0&id=ad615f4e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad615f4e",
  null
  
)

export default component.exports